import type { PlanReview } from "@/api/order_check";

/** Состояние значка «раскладка = заказ» (`PlanCheck.tsx`): живой план паллет
 *  портала (реестр грузомест, этап 3в) против заказа в 1С.
 *  Отдельным модулем: файл компонентов экспортирует только компоненты. */
export type PlanCheck =
  | { kind: "loading" }
  | { kind: "error"; error: unknown }
  /** Свободный режим без раскладки — сверять нечего, значка нет. */
  | { kind: "free" }
  | { kind: "no-plan"; review: PlanReview }
  /** Свободный режим, а раскладка ЕСТЬ — сессия её ещё не взяла («Обновить план»). */
  | { kind: "unloaded"; review: PlanReview }
  | { kind: "mismatch"; review: PlanReview }
  /** План сессии разошёлся с заказом. `review: null` — у перемещения: значок
   *  сверку раскладки не запрашивает, есть только `plan_coverage`. */
  | { kind: "stale"; review: PlanReview | null }
  | { kind: "ok"; review: PlanReview };

export function planCheckState(
  q: { data: PlanReview | undefined; error: unknown; isError: boolean; isFetching: boolean },
  detail: { is_directive: boolean; plan_coverage: string[] },
): PlanCheck {
  // Перепроверка тоже «серая»: иначе тап «Перепроверить» ничем не отличался
  // бы от тапа мимо, а старый зелёный значок выдавал бы себя за свежий.
  if (q.isFetching) return { kind: "loading" };
  if (q.isError) return { kind: "error", error: q.error };
  const review = q.data;
  if (!review) return { kind: "loading" };
  if (!review.has_plan) return detail.is_directive ? { kind: "no-plan", review } : { kind: "free" };
  // Раскладка есть, а сборка идёт без плана — сначала обновить план:
  // «Раскладка ✓» здесь соврала бы, гейт скана по ней не сверяет вовсе.
  if (!detail.is_directive) return { kind: "unloaded", review };
  if (!review.in_sync) return { kind: "mismatch", review };
  if (detail.plan_coverage.length > 0) return { kind: "stale", review };
  return { kind: "ok", review };
}

/** Перемещение: значок сверку раскладки не запрашивает (ручка с этапа 3в её
 *  умеет, экран — пока нет), но план директивной сессии сверяется с заказом
 *  (`plan_coverage`) — разошёлся, значит «План устарел», и нужна кнопка
 *  «Обновить план». */
export function transferPlanCheckState(detail: { plan_coverage: string[] }): PlanCheck {
  return detail.plan_coverage.length > 0 ? { kind: "stale", review: null } : { kind: "free" };
}
